import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { MediaStateInfo } from '../../types/generated/MediaStateInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetMediaStateMutationVariables = Types.Exact<{
  mediaStateId: Types.Scalars['ID']['input'];
  mediaState: Types.MediaStateInput;
  mediaStateIndex: Types.Scalars['Number']['input'];
}>;


export type SetMediaStateMutation = { __typename?: 'Mutation', setMediaState: { __typename?: 'MediaState', id?: string | null, currentCaptionIndex?: number | null, currentHlsManifestUrl?: string | null, currentTime?: number | null, currentTimeLastUpdated?: number | null, duration?: number | null, fps?: number | null, frames?: number | null, elementDuration?: number | null, hasUpdatedTime?: boolean | null, hotkeyPlaybackRate?: number | null, isReady?: boolean | null, isSeeking?: boolean | null, isTranscriptionPanelOpen?: boolean | null, lastVolume?: number | null, customLoop?: boolean | null, mediaStartUTC?: number | null, muted?: boolean | null, paused?: boolean | null, playbackRateAudio?: number | null, playbackRateVideo?: number | null, overlayPlayButtonWasDismissed?: boolean | null, volume?: number | null, currentPage?: number | null, isPageDrawerOpen?: boolean | null, isPageDrawerAvailable?: boolean | null, isPanning?: boolean | null, isPdfLoaded?: boolean | null, shouldFallbackToImagePane?: boolean | null, pageCount?: number | null, currentUrl?: string | null, currentUrlPath?: string | null, liveUrlExternalUrl?: string | null, iframeWidth?: number | null, iframeHeight?: number | null, scrollX?: number | null, scrollY?: number | null, resolutionLastChangedBy?: string | null, resolutionType?: string | null, activeZoom?: Types.ZoomSetting | null, cachedFrameGuide?: string | null, fillZoomValue?: number | null, fitZoomValue?: number | null, focalPointX?: number | null, focalPointY?: number | null, frameGuide?: string | null, isDragging?: boolean | null, isFullscreen?: boolean | null, isMaskOn?: boolean | null, lastZoom?: number | null, viewHeight?: number | null, viewLeft?: number | null, viewTop?: number | null, viewWidth?: number | null, zoom?: number | null, rangeStart?: number | null, rangeDuration?: number | null, isRangeSelectorVisible?: boolean | null } };


export const SetMediaState = /*#__PURE__*/ gql`
    mutation SetMediaState($mediaStateId: ID!, $mediaState: MediaStateInput!, $mediaStateIndex: Number!) {
  setMediaState(
    mediaStateId: $mediaStateId
    mediaState: $mediaState
    mediaStateIndex: $mediaStateIndex
  ) @client {
    ...MediaStateInfo
  }
}
    ${MediaStateInfo}` as unknown as DocumentNode<SetMediaStateMutation, SetMediaStateMutationVariables>;

          

          export const useSetMediaStateMutation = (options?:MutationHookOptions<SetMediaStateMutation, SetMediaStateMutationVariables>) => useMutation(SetMediaState, options);
          

          export type SetMediaStateMutationOptions = MutationHookOptions<SetMediaStateMutation, SetMediaStateMutationVariables>;

          

          export type SetMediaStateMutationResult = ReturnType<typeof useSetMediaStateMutation>[1];

          
